/**
 * @author Andres Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaBodegasTiposPropiedadesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaBodegasTiposPropiedades: React.FunctionComponent<ITablaBodegasTiposPropiedadesVistaProps &
    InjectedIntlProps> = ({
    bodegasTiposPropiedadess,
    cargarBodegasTiposPropiedades,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={bodegasTiposPropiedadess}
            actions={acciones(
                manejarFormulario,
                cargarBodegasTiposPropiedades,
                intl.formatMessage,
                confirmarEliminacion
            )}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaBodegasTiposPropiedades);
